import { render, staticRenderFns } from "./formSix.vue?vue&type=template&id=1b301bb2&scoped=true&"
import script from "./formSix.vue?vue&type=script&lang=js&"
export * from "./formSix.vue?vue&type=script&lang=js&"
import style0 from "./formSix.vue?vue&type=style&index=0&id=1b301bb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b301bb2",
  null
  
)

export default component.exports